module.exports = __webpack_public_path__ + "img/能效分析.d28c48b9.png";